// src/data/tours.js

import regSilkRoad from "../photos/tours_reg_silk_road.png";

export const tours = [
    {
        id: 1,
        title: "Ouzbékistan – Sur les traces de la Route de la Soie",
        duration: "11 jours / 10 nuits",
        price: "Sur devis",
        description:
            "Un voyage de Khiva à Tachkent, en passant par Boukhara, Samarkand et une nuit sous la yourte : mausolées timourides, médersas séculaires, bazars couverts et ateliers d'artisans, guidés en français du premier au dernier jour.",

        gallery: [
            regSilkRoad
        ],

        // Programme jour par jour
        programme: [
            {
                jour: 0,
                date: "2026-09-04",
                titre: "Paris – Ourguench",
                ville: "En vol",
                description:
                    "Rendez-vous à l'aéroport selon l'horaire convenu. Envol à destination d'Ourguench sur vol Uzbekistan Airways. Nuit à bord.",
                activites: [],
                repas: [],
            },
            {
                jour: 1,
                date: "2026-09-05",
                titre: "Ourguench / Khiva",
                ville: "Khiva",
                description:
                    "Arrivée à l'aéroport d'Ourguench et accueil par le guide francophone. Route pour Khiva, véritable ville-musée derrière ses murailles, coupoles et minarets, ancienne capitale du royaume de Khorezm.",
                activites: [
                    "Installation à l'hôtel",
                    "Médersa Muhammad Amin Khan et minaret Kalta",
                    "Forteresse Koukhna Ark (mosquée Juma, Salle du Trône, Chancellerie)",
                    "Médersa Muhammad Rahim Khan",
                    "Mausolée Sayyid Alaouddin, l'un des plus anciens monuments de Khiva",
                    "Coucher de soleil sur la ville",
                    "Palais Tosh Khaouli (« Palais de Pierre »)",
                    "Médersa et caravansérail Allakouli Khan",
                    "Mosquée du Vendredi (213 colonnes en bois sculpté)",
                    "Médersa Islam Khodja et son minaret, le plus haut de la ville",
                    "Mausolée Pakhlavan Makhmud",
                    "Musée Mennonite de Khiva",
                    "Atelier de sculpture sur bois",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Khiva",
            },
            {
                jour: 2,
                date: "2026-09-06",
                titre: "Khiva – Boukhara",
                ville: "Boukhara",
                description:
                    "Trajet routier vers Boukhara avec déjeuner en cours de route. Arrivée et installation à l'hôtel.",
                activites: [
                    "Balade au centre de la vieille ville, Labi Khauz",
                    "Atelier de marionnettes de Boukhara",
                    "Soirée folklorique dans la médersa Nodir Devon Begi",
                ],
                repas: ["dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 3,
                date: "2026-09-07",
                titre: "Boukhara",
                ville: "Boukhara",
                description:
                    "Boukhara, surnommée « la perle de l'Islam » au XIIe siècle, seconde grande étape ouzbèke de la Route de la Soie.",
                activites: [
                    "Citadelle Ark et sa salle de réception",
                    "Mosquée Bolo Khauz",
                    "Mausolée Samanide, premier édifice en brique cuite d'Asie Centrale",
                    "Ensemble Poi Kalyan : minaret et mosquée de Kalyan",
                    "Atelier de couteaux de Boukhara",
                    "Médersa Miri Arab",
                    "Coupoles des marchands : Toki Zargaron, Toki Sarrafon, Toki Telpakfourouchon",
                    "Ensemble Labi Khauz et médersa Nodir Devon Begi",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 4,
                date: "2026-09-08",
                titre: "Boukhara",
                ville: "Boukhara",
                description: "Journée consacrée aux environs de Boukhara et à ses lieux sacrés.",
                activites: [
                    "Sitorai Mohi Khosa, résidence d'été des émirs de Boukhara",
                    "Ensemble Bakhaouddin Nakhshbandi, lieu le plus sacré de Boukhara",
                    "Atelier de papier de soie et de miniature",
                    "Tchor Bakr, l'un des plus beaux ensembles de Boukhara",
                    "Tchor Minor, les 4 minarets bleus",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 5,
                date: "2026-09-09",
                titre: "Boukhara – Nourata – Yourte",
                ville: "Camp de yourtes",
                description:
                    "Arrêt à Nourata, petite ville au pied des montagnes du même nom, entre la steppe affamée et le désert de Kyzylkoum.",
                activites: [
                    "Complexe de Tchashma, l'un des plus importants centres islamiques de la région",
                    "Mosquée Juma et ancienne forteresse Nour",
                    "Route vers le camp de yourtes",
                    "Balade à dos de chameau",
                ],
                repas: ["dejeuner", "diner"],
                nuit: "Yourte",
            },
            {
                jour: 6,
                date: "2026-09-10",
                titre: "Yourte – Samarkand",
                ville: "Samarkand",
                description: "Départ vers Samarkand, déjeuner en route, installation à l'hôtel l'après-midi.",
                activites: ["Mausolée de Tamerlan (Timour)"],
                repas: ["dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 7,
                date: "2026-09-11",
                titre: "Samarkand",
                ville: "Samarkand",
                description:
                    "Samarcande, fondée au Ve siècle av. J.-C., capitale de l'empire sogdien avant Alexandre le Grand puis Gengis Khan.",
                activites: [
                    "Place du Reghistan et ses trois médersas",
                    "Nécropole Chakh-i-Zinda et ses 20 mausolées timourides",
                    "Mosquée Khazrati Khizr",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 8,
                date: "2026-09-12",
                titre: "Samarkand – Shahrisabz",
                ville: "Shahrisabz",
                description:
                    "La ville « verte », ancienne Ketch, ville natale de Tamerlan, classée à l'UNESCO en 1993.",
                activites: [
                    "Route à travers les monts Zeravchan",
                    "Ak-Saraï, le « Palais Blanc »",
                    "Mosquée Kok Goumbaz",
                    "Mausolée Gumbazi-Seidan",
                    "Mausolées Dorut Tilovat et Dorut Siadat",
                    "Arrêt dans les montagnes de Pamir",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 9,
                date: "2026-09-13",
                titre: "Samarkand",
                ville: "Samarkand",
                description: "Journée dédiée aux grands monuments scientifiques et religieux de Samarkand.",
                activites: [
                    "Observatoire d'Oulougbek",
                    "Musée Afrosiab",
                    "Mausolée du prophète Daniel",
                    "Mosquée Bibi Khanym",
                    "Grand bazar de Samarkand",
                    "Départ vers Tachkent en train Afrosiab",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Tachkent",
            },
            {
                jour: 10,
                date: "2026-09-14",
                titre: "Tachkent",
                ville: "Tachkent",
                description: "Première découverte de la capitale ouzbèque, puis transfert vers l'aéroport.",
                activites: [
                    "Place d'Indépendance et Place Amir Timour",
                    "Métro de Tachkent, seul métro d'Asie Centrale",
                    "Place Khast-i-Imam, centre religieux de Tachkent",
                    "Médersa et mausolée Barak Khan",
                    "Mosquée du Vendredi et médersa Moyie Moubarak",
                    "Transfert à l'aéroport",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: null,
            },
        ],

        inclus: [
            "Transport",
            "Hébergements",
            "Repas (thé et eau minérale inclus)",
            "Guide accompagnateur francophone",
            "Entrées des musées et monuments",
            "Une bouteille d'eau de 0,5L par jour",
            "Soirée folklorique dans la médersa Nodir Devon Begi",
            "Porteurs de bagages",
        ],
        nonInclus: [
            "Vol international",
            "Taxes photos et films sur les sites visités (20 €)",
            "Assurance obligatoire de rapatriement",
            "Boissons supplémentaires et dépenses personnelles",
            "Supplément chambre individuelle (220 €)",
            "Pourboires (chauffeurs 2–3 €/jour, guides 5–7 €/jour et par personne)",
        ],
    },
    {
        id: 2,
        title: "Ouzbékistan – Grand Tour de la Route de la Soie (15 jours)",
        duration: "15 jours / 14 nuits",
        price: "Sur devis",
        description:
            "Le tour complet de l'Ouzbékistan, au départ de Tachkent : Khiva, Boukhara, une nuit sous la yourte, Samarkand, Shahrisabz et la vallée de Ferghana. Mausolées timourides, forteresses du désert, ateliers d'artisans et routes de montagne, guidés en français du premier au dernier jour.",

        gallery: [
            regSilkRoad
        ],

        // Programme jour par jour
        programme: [
            {
                jour: 0,
                date: "2026-10-02",
                titre: "Paris – Tachkent",
                ville: "En vol",
                description:
                    "Rendez-vous à l'aéroport selon l'horaire convenu. Envol à destination de Tachkent sur vol Uzbekistan Airways. Nuit à bord.",
                activites: [],
                repas: [],
            },
            {
                jour: 1,
                date: "2026-10-03",
                titre: "Tachkent",
                ville: "Tachkent",
                description:
                    "Arrivée à Tachkent et accueil par le guide francophone. Installation à l'hôtel puis première découverte de la capitale ouzbèke, mélange d'architecture soviétique et de monuments islamiques restaurés.",
                activites: [
                    "Installation à l'hôtel",
                    "Place d'Indépendance et ses jardins",
                    "Place Amir Timour et son monument équestre",
                    "Métro de Tachkent, seul métro d'Asie Centrale, aux stations décorées",
                    "Marché Tchorsou et son dôme bleu",
                    "Dîner de bienvenue",
                ],
                repas: ["dejeuner", "diner"],
                nuit: "Tachkent",
            },
            {
                jour: 2,
                date: "2026-10-04",
                titre: "Tachkent – Khiva",
                ville: "Khiva",
                description:
                    "Matinée consacrée au centre religieux de la capitale, puis vol intérieur pour Khiva, véritable ville-musée derrière ses murailles de terre crue.",
                activites: [
                    "Place Khast-i-Imam, centre religieux de Tachkent",
                    "Médersa et mausolée Barak Khan",
                    "Mosquée du Vendredi et médersa Moyie Moubarak",
                    "Transfert à l'aéroport et vol pour Ourguench",
                    "Route pour Khiva, installation à l'hôtel",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Khiva",
            },
            {
                jour: 3,
                date: "2026-10-05",
                titre: "Khiva",
                ville: "Khiva",
                description:
                    "Journée complète dans la cité fortifiée d'Itchan Kala, ancienne capitale du royaume de Khorezm et étape majeure des caravanes vers la Perse.",
                activites: [
                    "Médersa Muhammad Amin Khan et minaret Kalta",
                    "Forteresse Koukhna Ark (mosquée Juma, Salle du Trône, Chancellerie)",
                    "Médersa Muhammad Rahim Khan",
                    "Mausolée Sayyid Alaouddin, l'un des plus anciens monuments de Khiva",
                    "Palais Tosh Khaouli (« Palais de Pierre »)",
                    "Médersa et caravansérail Allakouli Khan",
                    "Mosquée du Vendredi (213 colonnes en bois sculpté)",
                    "Médersa Islam Khodja et son minaret, le plus haut de la ville",
                    "Mausolée Pakhlavan Makhmud",
                    "Atelier de sculpture sur bois",
                    "Coucher de soleil depuis les remparts",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Khiva",
            },
            {
                jour: 4,
                date: "2026-10-06",
                titre: "Khiva – Boukhara",
                ville: "Boukhara",
                description:
                    "Longue traversée du désert du Kyzylkoum, avec un arrêt sur les rives de l'Amou-Daria, avant l'arrivée à Boukhara en fin de journée.",
                activites: [
                    "Traversée du désert du Kyzylkoum",
                    "Arrêt photo sur les rives de l'Amou-Daria",
                    "Installation à l'hôtel",
                    "Balade au centre de la vieille ville, Labi Khauz",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 5,
                date: "2026-10-07",
                titre: "Boukhara",
                ville: "Boukhara",
                description:
                    "Boukhara, surnommée « la perle de l'Islam » au XIIe siècle, seconde grande étape ouzbèke de la Route de la Soie.",
                activites: [
                    "Citadelle Ark et sa salle de réception",
                    "Mosquée Bolo Khauz",
                    "Mausolée Samanide, premier édifice en brique cuite d'Asie Centrale",
                    "Ensemble Poi Kalyan : minaret et mosquée de Kalyan",
                    "Atelier de couteaux de Boukhara",
                    "Médersa Miri Arab",
                    "Coupoles des marchands : Toki Zargaron, Toki Sarrafon, Toki Telpakfourouchon",
                    "Soirée folklorique dans la médersa Nodir Devon Begi",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 6,
                date: "2026-10-08",
                titre: "Boukhara (environs)",
                ville: "Boukhara",
                description: "Journée consacrée aux environs de Boukhara et à ses lieux sacrés.",
                activites: [
                    "Sitorai Mohi Khosa, résidence d'été des émirs de Boukhara",
                    "Ensemble Bakhaouddin Nakhshbandi, lieu le plus sacré de Boukhara",
                    "Atelier de papier de soie et de miniature",
                    "Tchor Bakr, l'un des plus beaux ensembles de Boukhara",
                    "Tchor Minor, les 4 minarets bleus",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 7,
                date: "2026-10-09",
                titre: "Boukhara – Nourata – Yourte",
                ville: "Camp de yourtes",
                description:
                    "Arrêt à Nourata, petite ville au pied des montagnes du même nom, entre la steppe affamée et le désert de Kyzylkoum, avant une nuit typique sous la yourte.",
                activites: [
                    "Complexe de Tchashma, l'un des plus importants centres islamiques de la région",
                    "Mosquée Juma et ancienne forteresse Nour",
                    "Route vers le camp de yourtes",
                    "Balade à dos de chameau",
                    "Dîner traditionnel et soirée autour du feu",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Yourte",
            },
            {
                jour: 8,
                date: "2026-10-10",
                titre: "Yourte – Samarkand",
                ville: "Samarkand",
                description: "Départ vers Samarkand, déjeuner en route, installation à l'hôtel l'après-midi.",
                activites: [
                    "Route à travers la steppe et les vergers de la vallée du Zeravchan",
                    "Mausolée de Tamerlan (Gour Emir)",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 9,
                date: "2026-10-11",
                titre: "Samarkand",
                ville: "Samarkand",
                description:
                    "Samarcande, fondée au Ve siècle av. J.-C., capitale de l'empire sogdien avant Alexandre le Grand puis Gengis Khan, et joyau de l'empire timouride.",
                activites: [
                    "Place du Reghistan et ses trois médersas",
                    "Nécropole Chakh-i-Zinda et ses 20 mausolées timourides",
                    "Mosquée Khazrati Khizr",
                    "Grand bazar de Samarkand",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 10,
                date: "2026-10-12",
                titre: "Samarkand – Shahrisabz – Samarkand",
                ville: "Shahrisabz",
                description:
                    "Excursion à la journée dans la ville « verte », ancienne Ketch, ville natale de Tamerlan, classée à l'UNESCO en 1993.",
                activites: [
                    "Route à travers les monts Zeravchan",
                    "Ak-Saraï, le « Palais Blanc »",
                    "Mosquée Kok Goumbaz",
                    "Mausolée Gumbazi-Seidan",
                    "Mausolées Dorut Tilovat et Dorut Siadat",
                    "Retour à Samarkand en fin de journée",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 11,
                date: "2026-10-13",
                titre: "Samarkand – Tachkent",
                ville: "Tachkent",
                description:
                    "Matinée dédiée aux grands monuments scientifiques et religieux de Samarkand, puis retour vers la capitale en train à grande vitesse.",
                activites: [
                    "Observatoire d'Oulougbek",
                    "Musée Afrosiab",
                    "Mausolée du prophète Daniel",
                    "Mosquée Bibi Khanym",
                    "Départ vers Tachkent en train Afrosiab",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Tachkent",
            },
            {
                jour: 12,
                date: "2026-10-14",
                titre: "Tachkent – Vallée de Ferghana",
                ville: "Kokand",
                description:
                    "Route de montagne à travers la chaîne du Tian Chan et le col de Kamchik, porte d'entrée vers la vallée de Ferghana, berceau de Babur.",
                activites: [
                    "Traversée du col de Kamchik (2 268 m)",
                    "Arrêt photo dans les gorges du Tchirtchik",
                    "Palais Khoudoïar Khan à Kokand",
                    "Installation à l'hôtel",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Kokand",
            },
            {
                jour: 13,
                date: "2026-10-15",
                titre: "Kokand – Marguilan – Richtan – Andijan",
                ville: "Andijan",
                description:
                    "Journée consacrée à l'artisanat vivant de la vallée de Ferghana : soie de Marguilan, céramique de Richtan et ville natale de Babur à Andijan.",
                activites: [
                    "Atelier de soie « Yodgorlik » à Marguilan",
                    "Rue des artisans de Marguilan et ses maisons en bois",
                    "Ateliers de céramique de Richtan",
                    "Route vers Andijan",
                    "Parc et musée Babur à Andijan",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Andijan",
            },
            {
                jour: 14,
                date: "2026-10-16",
                titre: "Vallée de Ferghana – Tachkent – Départ",
                ville: "Tachkent",
                description:
                    "Retour vers Tachkent par la route de montagne, dernière halte shopping puis transfert à l'aéroport pour le vol retour.",
                activites: [
                    "Retour vers Tachkent via le col de Kamchik",
                    "Temps libre au marché Tchorsou pour les derniers souvenirs",
                    "Déjeuner d'adieu",
                    "Transfert à l'aéroport",
                ],
                repas: ["petit_dejeuner", "dejeuner"],
                nuit: null,
            },
        ],

        inclus: [
            "Transport (véhicule climatisé + vol intérieur Tachkent–Ourguench + train Afrosiab Samarkand–Tachkent)",
            "Hébergements en hôtels 3-4* et une nuit en camp de yourtes",
            "Repas mentionnés au programme (thé et eau minérale inclus)",
            "Guide accompagnateur francophone durant tout le circuit",
            "Entrées des musées et monuments mentionnés au programme",
            "Une bouteille d'eau de 0,5L par jour",
            "Soirée folklorique dans la médersa Nodir Devon Begi",
            "Balade à dos de chameau",
            "Porteurs de bagages",
        ],
        nonInclus: [
            "Vol international",
            "Taxes photos et films sur les sites visités (25 €)",
            "Assurance obligatoire de rapatriement",
            "Boissons supplémentaires et dépenses personnelles",
            "Supplément chambre individuelle (320 €)",
            "Pourboires (chauffeurs 2–3 €/jour, guides 5–7 €/jour et par personne)",
        ],
    },

    {
        id: 3,
        title: "Ouzbékistan – Grand Tour Intégral (20 jours) – De Samarkand à travers tout le pays",
        duration: "20 jours / 19 nuits",
        price: "Sur devis",
        description:
            "Le tour le plus complet de l'Ouzbékistan, au départ de Samarkand : Shahrisabz, Boukhara, une nuit sous la yourte, Khiva, le Karakalpakstan et le désert du Kyzylkoum, Tachkent, toute la vallée de Ferghana et enfin Termez au sud, aux portes de l'Afghanistan. Mausolées timourides, forteresses antiques de Khorezm, ateliers d'artisans, sites bouddhiques et routes de montagne : les 20 jours parcourent l'ensemble des régions historiques du pays, guidés en français du premier au dernier jour.",

        gallery: [
            regSilkRoad
        ],

        // Programme jour par jour
        programme: [
            {
                jour: 0,
                date: "2026-11-06",
                titre: "Paris – Samarkand",
                ville: "En vol",
                description:
                    "Rendez-vous à l'aéroport selon l'horaire convenu. Envol à destination de Samarkand via Tachkent sur vol Uzbekistan Airways. Nuit à bord.",
                activites: [],
                repas: [],
            },
            {
                jour: 1,
                date: "2026-11-07",
                titre: "Samarkand",
                ville: "Samarkand",
                description:
                    "Arrivée à Samarkand et accueil par le guide francophone. Installation à l'hôtel puis première découverte de la ville la plus mythique de la Route de la Soie, fondée au Ve siècle av. J.-C.",
                activites: [
                    "Installation à l'hôtel",
                    "Place du Reghistan et ses trois médersas",
                    "Mausolée de Tamerlan (Gour Emir)",
                    "Dîner de bienvenue",
                ],
                repas: ["dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 2,
                date: "2026-11-08",
                titre: "Samarkand",
                ville: "Samarkand",
                description:
                    "Journée dédiée aux grands monuments scientifiques et religieux de Samarkand, capitale de l'empire timouride.",
                activites: [
                    "Nécropole Chakh-i-Zinda et ses 20 mausolées timourides",
                    "Mosquée Khazrati Khizr",
                    "Mosquée Bibi Khanym",
                    "Observatoire d'Oulougbek",
                    "Musée Afrosiab",
                    "Mausolée du prophète Daniel",
                    "Grand bazar de Samarkand",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 3,
                date: "2026-11-09",
                titre: "Samarkand – Shahrisabz – Samarkand",
                ville: "Shahrisabz",
                description:
                    "Excursion à la journée dans la ville « verte », ancienne Ketch, ville natale de Tamerlan, classée à l'UNESCO en 1993.",
                activites: [
                    "Route à travers les monts Zeravchan",
                    "Ak-Saraï, le « Palais Blanc »",
                    "Mosquée Kok Goumbaz",
                    "Mausolée Gumbazi-Seidan",
                    "Mausolées Dorut Tilovat et Dorut Siadat",
                    "Retour à Samarkand en fin de journée",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Samarkand",
            },
            {
                jour: 4,
                date: "2026-11-10",
                titre: "Samarkand – Boukhara",
                ville: "Boukhara",
                description:
                    "Route vers Boukhara à travers la vallée du Zeravchan, avec déjeuner en cours de route. Installation à l'hôtel et première balade dans la vieille ville.",
                activites: [
                    "Balade au centre de la vieille ville, Labi Khauz",
                    "Atelier de marionnettes de Boukhara",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 5,
                date: "2026-11-11",
                titre: "Boukhara",
                ville: "Boukhara",
                description:
                    "Boukhara, surnommée « la perle de l'Islam » au XIIe siècle, seconde grande étape ouzbèke de la Route de la Soie.",
                activites: [
                    "Citadelle Ark et sa salle de réception",
                    "Mosquée Bolo Khauz",
                    "Mausolée Samanide, premier édifice en brique cuite d'Asie Centrale",
                    "Ensemble Poi Kalyan : minaret et mosquée de Kalyan",
                    "Atelier de couteaux de Boukhara",
                    "Médersa Miri Arab",
                    "Coupoles des marchands : Toki Zargaron, Toki Sarrafon, Toki Telpakfourouchon",
                    "Soirée folklorique dans la médersa Nodir Devon Begi",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 6,
                date: "2026-11-12",
                titre: "Boukhara (environs)",
                ville: "Boukhara",
                description: "Journée consacrée aux environs de Boukhara et à ses lieux sacrés.",
                activites: [
                    "Sitorai Mohi Khosa, résidence d'été des émirs de Boukhara",
                    "Ensemble Bakhaouddin Nakhshbandi, lieu le plus sacré de Boukhara",
                    "Atelier de papier de soie et de miniature",
                    "Tchor Bakr, l'un des plus beaux ensembles de Boukhara",
                    "Tchor Minor, les 4 minarets bleus",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Boukhara",
            },
            {
                jour: 7,
                date: "2026-11-13",
                titre: "Boukhara – Nourata – Yourte",
                ville: "Camp de yourtes",
                description:
                    "Arrêt à Nourata, petite ville au pied des montagnes du même nom, entre la steppe affamée et le désert de Kyzylkoum, avant une nuit typique sous la yourte.",
                activites: [
                    "Complexe de Tchashma, l'un des plus importants centres islamiques de la région",
                    "Mosquée Juma et ancienne forteresse Nour",
                    "Route vers le camp de yourtes",
                    "Balade à dos de chameau",
                    "Dîner traditionnel et soirée autour du feu",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Yourte",
            },
            {
                jour: 8,
                date: "2026-11-14",
                titre: "Yourte – Khiva",
                ville: "Khiva",
                description:
                    "Longue traversée du désert du Kyzylkoum en direction de Khiva, ancienne capitale du royaume de Khorezm.",
                activites: [
                    "Traversée du désert du Kyzylkoum",
                    "Arrêt photo sur les rives de l'Amou-Daria",
                    "Installation à l'hôtel",
                    "Coucher de soleil depuis les remparts d'Itchan Kala",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Khiva",
            },
            {
                jour: 9,
                date: "2026-11-15",
                titre: "Khiva",
                ville: "Khiva",
                description:
                    "Journée complète dans la cité fortifiée d'Itchan Kala, véritable ville-musée derrière ses murailles de terre crue.",
                activites: [
                    "Médersa Muhammad Amin Khan et minaret Kalta",
                    "Forteresse Koukhna Ark (mosquée Juma, Salle du Trône, Chancellerie)",
                    "Médersa Muhammad Rahim Khan",
                    "Mausolée Sayyid Alaouddin, l'un des plus anciens monuments de Khiva",
                    "Palais Tosh Khaouli (« Palais de Pierre »)",
                    "Médersa et caravansérail Allakouli Khan",
                    "Mosquée du Vendredi (213 colonnes en bois sculpté)",
                    "Médersa Islam Khodja et son minaret, le plus haut de la ville",
                    "Mausolée Pakhlavan Makhmud",
                    "Atelier de sculpture sur bois",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Khiva",
            },
            {
                jour: 10,
                date: "2026-11-16",
                titre: "Khiva – Noukous",
                ville: "Noukous",
                description:
                    "Route vers le Karakalpakstan, région autonome au bord de l'ancienne mer d'Aral, avec un détour par les forteresses antiques du désert de Khorezm.",
                activites: [
                    "Forteresse d'Ayaz Kala, citadelle du désert vieille de 2 000 ans",
                    "Forteresse de Toprak Kala",
                    "Route vers Noukous",
                    "Installation à l'hôtel",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Noukous",
            },
            {
                jour: 11,
                date: "2026-11-17",
                titre: "Noukous",
                ville: "Noukous",
                description:
                    "Découverte de Noukous, capitale du Karakalpakstan, célèbre pour son musée d'art unique au monde et ses sites funéraires antiques.",
                activites: [
                    "Musée d'art Igor Savitsky (avant-garde russe interdite)",
                    "Nécropole de Mizdakhan, l'un des plus grands cimetières d'Asie Centrale",
                    "Mausolée de Chilpik, tour du silence zoroastrienne",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Noukous",
            },
            {
                jour: 12,
                date: "2026-11-18",
                titre: "Noukous – Tachkent",
                ville: "Tachkent",
                description:
                    "Vol intérieur vers Tachkent. Installation à l'hôtel et première découverte de la capitale ouzbèke.",
                activites: [
                    "Transfert à l'aéroport et vol pour Tachkent",
                    "Installation à l'hôtel",
                    "Place d'Indépendance et ses jardins",
                    "Place Amir Timour et son monument équestre",
                    "Métro de Tachkent, seul métro d'Asie Centrale, aux stations décorées",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Tachkent",
            },
            {
                jour: 13,
                date: "2026-11-19",
                titre: "Tachkent",
                ville: "Tachkent",
                description: "Journée consacrée au centre religieux historique de la capitale et à son marché emblématique.",
                activites: [
                    "Place Khast-i-Imam, centre religieux de Tachkent",
                    "Médersa et mausolée Barak Khan",
                    "Mosquée du Vendredi et médersa Moyie Moubarak",
                    "Marché Tchorsou et son dôme bleu",
                    "Musée des Beaux-Arts d'Ouzbékistan",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Tachkent",
            },
            {
                jour: 14,
                date: "2026-11-20",
                titre: "Tachkent – Vallée de Ferghana",
                ville: "Kokand",
                description:
                    "Route de montagne à travers la chaîne du Tian Chan et le col de Kamchik, porte d'entrée vers la vallée de Ferghana, berceau de Babur.",
                activites: [
                    "Traversée du col de Kamchik (2 268 m)",
                    "Arrêt photo dans les gorges du Tchirtchik",
                    "Palais Khoudoïar Khan à Kokand",
                    "Installation à l'hôtel",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Kokand",
            },
            {
                jour: 15,
                date: "2026-11-21",
                titre: "Kokand – Marguilan – Richtan – Andijan",
                ville: "Andijan",
                description:
                    "Journée consacrée à l'artisanat vivant de la vallée de Ferghana : soie de Marguilan, céramique de Richtan et ville natale de Babur à Andijan.",
                activites: [
                    "Atelier de soie « Yodgorlik » à Marguilan",
                    "Rue des artisans de Marguilan et ses maisons en bois",
                    "Ateliers de céramique de Richtan",
                    "Route vers Andijan",
                    "Parc et musée Babur à Andijan",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Andijan",
            },
            {
                jour: 16,
                date: "2026-11-22",
                titre: "Andijan – Namangan – Ferghana",
                ville: "Ferghana",
                description:
                    "Route vers Namangan puis Ferghana, découvrant l'architecture soviétique et les paysages agricoles de la vallée la plus peuplée d'Asie Centrale.",
                activites: [
                    "Mosquée Khodjamny Kabri à Namangan",
                    "Route à travers les vergers de la vallée de Ferghana",
                    "Centre-ville colonial russe de Ferghana",
                    "Installation à l'hôtel",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Ferghana",
            },
            {
                jour: 17,
                date: "2026-11-23",
                titre: "Ferghana – Tachkent",
                ville: "Tachkent",
                description:
                    "Retour vers Tachkent via le col de Kamchik, avec un dernier arrêt shopping avant le vol du soir vers le sud du pays.",
                activites: [
                    "Retour vers Tachkent via le col de Kamchik",
                    "Temps libre au marché Tchorsou pour les derniers souvenirs",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Tachkent",
            },
            {
                jour: 18,
                date: "2026-11-24",
                titre: "Tachkent – Termez",
                ville: "Termez",
                description:
                    "Vol vers Termez, aux portes de l'Afghanistan, ancienne étape majeure du bouddhisme sur la Route de la Soie et ville la plus méridionale du pays.",
                activites: [
                    "Transfert à l'aéroport et vol pour Termez",
                    "Complexe Sultan Saodat",
                    "Forteresse et mosquée Kirk Kiz",
                    "Musée archéologique de Termez",
                ],
                repas: ["petit_dejeuner", "dejeuner", "diner"],
                nuit: "Termez",
            },
            {
                jour: 19,
                date: "2026-11-25",
                titre: "Termez – Tachkent – Départ",
                ville: "En vol",
                description:
                    "Dernière matinée consacrée aux sites bouddhiques et soufis de Termez, puis vol retour vers Tachkent et transfert à l'aéroport international pour le vol retour.",
                activites: [
                    "Stoupa bouddhique de Fayaz Tepa",
                    "Mausolée Hakim al-Termizi",
                    "Vol retour vers Tachkent",
                    "Déjeuner d'adieu",
                    "Transfert à l'aéroport international",
                ],
                repas: ["petit_dejeuner", "dejeuner"],
                nuit: null,
            },
        ],

        inclus: [
            "Transport (véhicule climatisé + vols intérieurs Noukous–Tachkent et Tachkent–Termez–Tachkent)",
            "Hébergements en hôtels 3-4* et une nuit en camp de yourtes",
            "Repas mentionnés au programme (thé et eau minérale inclus)",
            "Guide accompagnateur francophone durant tout le circuit",
            "Entrées des musées et monuments mentionnés au programme",
            "Une bouteille d'eau de 0,5L par jour",
            "Soirée folklorique dans la médersa Nodir Devon Begi",
            "Balade à dos de chameau",
            "Porteurs de bagages",
        ],
        nonInclus: [
            "Vol international",
            "Taxes photos et films sur les sites visités (30 €)",
            "Assurance obligatoire de rapatriement",
            "Boissons supplémentaires et dépenses personnelles",
            "Supplément chambre individuelle (400 €)",
            "Pourboires (chauffeurs 2–5 €/jour, guides 5–10 €/jour et par personne)",
        ],
    },
];